import { render, staticRenderFns } from "./excellentEnterpriserEcommendInfo.vue?vue&type=template&id=80d9233a&scoped=true"
import script from "./excellentEnterpriserEcommendInfo.vue?vue&type=script&lang=js"
export * from "./excellentEnterpriserEcommendInfo.vue?vue&type=script&lang=js"
import style0 from "./excellentEnterpriserEcommendInfo.vue?vue&type=style&index=0&id=80d9233a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d9233a",
  null
  
)

export default component.exports